












































import Vue, { PropType } from 'vue';
import { WithEvents } from 'vue-typed-emit';

import { SldsButton, SldsTooltip } from '@ui';
import { LiceseType, Realm } from '@/types';
import { computed, toRefs } from '@vue/composition-api';
import { useViewer } from '@/composables';

export interface Events {
  disconnect: undefined;
}

type Connection = {
  domain: string;
  realm: Realm;
  trialEndTime: Date | null;
  username: string;
};

export default (Vue as WithEvents<Events>).extend({
  components: {
    SldsButton,
    SldsTooltip,
  },
  props: {
    connection: {
      type: Object as PropType<Connection>,
      required: true,
    },
  },
  setup(props, { emit }) {
    const { viewer } = useViewer();
    const { connection } = toRefs(props);
    const prettyDomain = computed(() => {
      const url = new URL(connection.value.domain as string);

      return url.host.split('.', 2)[0];
    });

    const expired = computed(() => {
      if (viewer.value?.license.type !== LiceseType.FREE) {
        return false;
      }
      return (
        connection.value.trialEndTime !== null &&
        new Date(connection.value.trialEndTime) < new Date()
      );
    });
    function disconnect() {
      emit('disconnect');
    }

    return { prettyDomain, expired, disconnect };
  },
});
